import BaseApi from './base/BaseApi';

export default class CrmFunnelMemberApi extends BaseApi {
  static entityName = 'crm_funnel_members';
}
